import {
  PiCheckCircle,
  PiClock,
  PiWarningCircle,
  PiXCircle,
} from 'react-icons/pi';
import { StatusPill } from 'src/modules/shared/components/atoms/status-pill';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import type { ExecutionDetailPresentation } from 'src/modules/automations/types/executions/execution-detail-presentation.type';
import type { ComponentVariant } from 'src/modules/shared/types/component.type';

interface ExecutionOutcomePillProps {
  /** Business-facing execution outcome. */
  outcome: ExecutionDetailPresentation['outcome'];
}

const OUTCOME_VARIANT: Record<
  ExecutionDetailPresentation['outcome'],
  ComponentVariant
> = {
  completed: 'success',
  failed: 'danger',
  running: 'info',
  blocked: 'warning',
};

/** Shared outcome presentation for execution summary and chronology. */
export const ExecutionOutcomePill: React.FC<ExecutionOutcomePillProps> = ({
  outcome,
}) => {
  const { t } = useI18n();
  const labelByOutcome = {
    completed: t('automations.aiAgents.executions.status.completed'),
    failed: t('automations.aiAgents.executions.status.failed'),
    running: t('automations.aiAgents.executions.status.running'),
    blocked: t('automations.aiAgents.executions.status.blocked'),
  };
  const iconByOutcome = {
    completed: <PiCheckCircle className="h-3.5 w-3.5" />,
    failed: <PiXCircle className="h-3.5 w-3.5" />,
    running: <PiClock className="h-3.5 w-3.5" />,
    blocked: <PiWarningCircle className="h-3.5 w-3.5" />,
  };

  return (
    <StatusPill
      label={labelByOutcome[outcome]}
      variant={OUTCOME_VARIANT[outcome]}
      appearance="soft"
      icon={iconByOutcome[outcome]}
    />
  );
};
